import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.format()
    this.element.addEventListener("input", () => this.format())
  }

  format() {
    const original = this.element.value
    const selectionStart = this.element.selectionStart

    let digits = original.replace(/\D/g, "").slice(0, 9)
    if (digits.length === 0) {
      this.element.value = ""
      return
    }

    const formatted = digits.replace(/\B(?=(\d{3})+(?!\d))/g, "\u00A0")

    if (this.element.value !== formatted) {
      const oldSeparators = original.match(/\u00A0/g) || []
      const newSeparators = formatted.match(/\u00A0/g) || []
      const addedSeparators = newSeparators.length - oldSeparators.length
      const removedDigits = original.replace(/\D/g, "").length - digits.length
      this.element.value = formatted

      const newCursor = Math.max(0, selectionStart + addedSeparators - removedDigits)
      this.element.setSelectionRange(newCursor, newCursor)
    }
  }
}
